import { pick } from 'ramda';
import api from './axiosApi';

export const validateStopMerge = async (
  depotCode,
  routeId,
  parcels,
  checkOpenRequests,
  shopUnsuitable,
  splitStop,
  routePlannerDowngrades,
  parcelValidated
) => {
  const { data } = await api.post(
    `/depot/${depotCode}/route/${routeId}/stop/validate`,
    {
      parcel: parcels.map((parcel) =>
        pick(['parcelCode', 'routeDate'], parcel)
      ),
      checkOpenRequests,
      shopUnsuitable,
      splitStop,
      routePlannerDowngrades,
      parcelValidated,
    },
    {
      ignoreSnackbarError: true,
    }
  );

  return data;
};
